import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Famille, HistoriqueElementNomenclature, Rubrique, Theme } from '../nomenclature.model';
import { NomenclatureService } from '../nomenclature.service';
import { GlobalModule } from '@app/_global/global.module';

@Component({
	selector: 'historique-element-nomenclature',
	template: `
		<div *ngIf="historique">
			{{historique.hno_date | date:'short'}}
			- {{historique | utilisateur:true}}
		</div>
	`
})
export class HistoriqueElementNomenclatureComponent implements OnInit {

	@Input() element: Rubrique | Theme | Famille;

	historique: HistoriqueElementNomenclature;

	constructor(private nomenclatureService: NomenclatureService) {

	}

	ngOnInit(): void {
		this.nomenclatureService.getHistoriqueElementNomenclature(this.element.hno_id)
		.subscribe((historique: HistoriqueElementNomenclature) => {
			this.historique = historique;
		});
	}

}

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		FormsModule,
	],
	exports: [HistoriqueElementNomenclatureComponent],
	declarations: [HistoriqueElementNomenclatureComponent]
})
export class HistoriqueElementNomenclatureModule { }
